export enum CartMutationTypes {
  SET_CART = 'SET_CART',
  MINICART_COUNT = 'MINICART_COUNT',
}
